import Map from './Map'

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedMap.html
 *
 * @extends {Map}
 * @constructor
 * @private
 */
export default function SortedMap() {};
SortedMap.prototype = new Map();
